import { convertUtcToLocal } from '@/utils/date'
import './PlanDateFieldModal.style.less'
import { Button, Col, DatePicker, Modal, Row, Switch } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { isEmptyValue } from '@/utils/common'

const { RangePicker } = DatePicker

function PlanDateFieldModal(props: {
  onClose: () => any
  onsubmit: (data) => any
  fieldName: string
  planStartDate: any
  planEndDate: any
  isRangeDate: any
}) {
  const { onClose, onsubmit } = props
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [showError, setshowError] = useState<string>(null)
  const [isEndDate, setIsEndDate] = useState(false)

  const [disable, setdisable] = useState(false)

  useEffect(() => {
    const date = new Date()

    if (props.isRangeDate) {
      setStartDate(
        moment(
          props.planStartDate ? convertUtcToLocal(props.planStartDate) : date
        )
      )
      setEndDate(
        moment(props.planEndDate ? convertUtcToLocal(props.planEndDate) : date)
      )
    } else {
      setStartDate(
        moment(
          props.planStartDate ? convertUtcToLocal(props.planStartDate) : date
        )
      )
      setEndDate(
        moment(
          props.planStartDate ? convertUtcToLocal(props.planStartDate) : date
        )
      )
    }

    setIsEndDate(props.isRangeDate ?? false)
  }, [])

  const onSubmit = () => {
    const payload = {
      startDate,
      endDate,
    }
    if (!startDate) setshowError(`Plan Date is required`)
    else onsubmit(payload)
  }

  const onSwitchRangeDate = (checked) => {
    setIsEndDate(checked)
    if (!checked) {
      setEndDate(startDate)
    }
    setdisable(false)
  }

  useEffect(() => {
    if (!isEmptyValue(props.planEndDate) || !isEmptyValue(props.planEndDate)) {
      setdisable(true)
    }
  }, [])

  return (
    <Modal
      className={'dialog-set-plan'}
      title={props.fieldName}
      width={600}
      open={true}
      onCancel={() => onClose()}
      footer={[
        <Button
          className="dialog-cancel-button default-dialog-button"
          key="cancel"
          type="primary"
          shape="round"
          onClick={() => onClose()}
        >
          Cancel
        </Button>,
        <Button
          className="default-dialog-button"
          key="save"
          type="primary"
          shape="round"
          disabled={disable}
          onClick={onSubmit}
        >
          Save
        </Button>,
      ]}
    >
      <div className="modal-plan-date-field">
        <Row align={'middle'}>
          <Col span={8}>
            <p className="title">Planned Date</p>
          </Col>
          <Col span={16}>
            {isEndDate ? (
              <RangePicker
                className={'br-1'}
                value={[startDate, endDate]}
                format="DD MMM YYYY"
                allowClear={false}
                onChange={(value: any) => {
                  setStartDate(value[0])
                  setEndDate(value[1])
                  setdisable(false)
                }}
              />
            ) : (
              <DatePicker
                className={'br-1'}
                autoFocus
                allowClear={false}
                style={{ width: '100%' }}
                placeholder={'Select a date'}
                value={startDate}
                format="DD MMM YYYY"
                onChange={(value: moment.Moment) => {
                  setStartDate(value)
                  setEndDate(value)
                  setdisable(false)
                }}
              />
            )}
            {showError && (
              <span className="field-required-text">{showError}</span>
            )}
          </Col>
        </Row>
        <Row align={'middle'} style={{ marginTop: 30 }}>
          <Col span={8}>
            <p className="title">End Date</p>
          </Col>
          <Col span={16}>
            <Switch checked={isEndDate} onChange={onSwitchRangeDate} />
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default PlanDateFieldModal
